// extracted by mini-css-extract-plugin
export var fullWidthButton = "_pj-0";